import {JSX} from "react";

import type {BookingDetails} from "../../types";

import "./booking-details-block.scss";

interface BookingDetailsBlockProps {
    left: BookingDetails;
    right?: BookingDetails;
}

export function BookingDetailsBlock({left, right}: BookingDetailsBlockProps): JSX.Element {
    return (
        <div className={`summary-card__kv ${right ? "summary-card__kv--two" : "summary-card__kv--one"}`}>
            <div className="summary-card__kv-col">
                <div className="summary-card__kv-label">{left.label}</div>
                <div className="summary-card__kv-value">{left.value}</div>
            </div>
            {right && (
                <div className="summary-card__kv-col">
                    <div className="summary-card__kv-label">{right.label}</div>
                    <div className="summary-card__kv-value">{right.value}</div>
                </div>
            )}
        </div>
    );
}
